export type SnMenuItemClickHandler<D> = (data?: D) => void;
